import { render, staticRenderFns } from "./EditName.vue?vue&type=template&id=c5466340&scoped=true"
import script from "./EditName.vue?vue&type=script&lang=js"
export * from "./EditName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5466340",
  null
  
)

export default component.exports